var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgOverdue = function SvgOverdue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10C8 9 7 7.5 6.5 7c-1.106 1.218-2.5 4.5-1 8-2-1-2.5-2.5-2.5-4.197C3 7.5 6 2.5 7.5 1c0 2.5.5 5.5 2.5 5.5.667 0 .889-.444 1.111-.889.111-.222.222-.444.389-.611.565 1.145 1.5 3.905 1.5 6 0 2.5-1.5 3.5-2.5 4 .5-.5 1.5-4.5-1-6l-1 1zm-1.645-.115c.233.667.44 1.258 1.13 1.59C9 11.5 9.5 10.5 9.5 10.5c.5.5.5 1.5.5 2C10 14 9 15 8 15s-2-1-2-2.5c0-.952 0-2.5.5-3.5.15.3.255.6.355.885z"
  })));
};

export default SvgOverdue;